module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/step4-pict01-full-1951302231facc9235f3866b47a68265.jpg";